module.exports = __webpack_public_path__ + "img/logo-maisribatejo.2b934b95.png";